import '@/store';
import '@/types/common';
import { httpClient } from '../../utils/http-client';
import RestService from '@/contracts/RestService';
export default class RecapService extends RestService {
    uri = 'recap';
    async render(data) {
        return (await httpClient.post(`${this.uri}/render`, data)).data;
    }
}
